import SourceProductReviews from 'SourceComponent/ProductReviews/ProductReviews.component';
import ProductReviewRating from 'Component/ProductReviewRating';
import ProductReviewGraph from 'Component/ProductReviewGraph';
import ShowMore from 'Component/ShowMore';

class ProductReviews extends SourceProductReviews {
    renderNoRating() {
        return (
            <p>
                { __('There are no reviews yet.') }
            </p>
        );
    }

    renderSummary() {
        const {
            product: {
                review_summary: {
                    review_count
                } = {}
            }
        } = this.props;

        const reviewSchemaObject = review_count
            ? {
                itemType: 'http://schema.org/AggregateRating',
                itemProp: 'aggregateRating',
                itemScope: true
            } : {};

        return (
            <div
              block="ProductReviews"
              elem="Summary"
              { ...reviewSchemaObject }
            >
                { this.renderRatingData() }
                { this.renderReviewGraph() }
                { this.renderButton() }
            </div>
        );
    }

    renderRatingData() {
        const {
            product: {
                review_summary: {
                    rating_summary,
                    review_count
                } = {}
            }
        } = this.props;

        const STARS_COUNT = 5;
        const PERCENT = 100;

        const percent = parseFloat(STARS_COUNT * (rating_summary || 0) / PERCENT).toFixed(2);

        if (!review_count) {
            return this.renderNoRating();
        }

        return (
            <>
                { this.renderRatingSchema(rating_summary, review_count) }
                <ProductReviewRating
                  mix={ { block: 'ProductReviews', elem: 'SummaryRating' } }
                  summary={ rating_summary }
                />
                <p block="ProductReviews" elem="SummaryDetails">
                    { __('%s from 5 stars', percent) }
                </p>
            </>
        );
    }

    renderReviewGraph() {
        const { product, areDetailsLoaded } = this.props;

        if (!areDetailsLoaded) {
            return null;
        }

        const { review_summary: { review_count_with_ratings, rating_graph } = {} } = product;

        return (
            <ProductReviewGraph total_votes={ review_count_with_ratings } stars={ rating_graph } />
        );
    }

    renderGraphListItem = (reviewItem) => {
        const { rating_votes } = reviewItem;

        return rating_votes.map((ratingVoteItem) => {
            const { percent } = ratingVoteItem;
            return percent;
        });
    };

    render() {
        const {
            product,
            areDetailsLoaded
        } = this.props;

        const {
            review_summary: { review_count } = {}
        } = product;

        if (!areDetailsLoaded) {
            return null;
        }

        return (
            <ShowMore mix={ { block: 'ProductReviews' } }>
                <div block="ProductSection" elem="Heading">
                    <h3 block="ProductSection" elem="HeadingTitle">
                        { __('Reviews') }
                    </h3>
                    { this.renderSummary() }
                </div>
                <div block="ProductSection" elem="Content">
                    { this.renderList() }
                    { this.renderPopup() }
                </div>
            </ShowMore>
        );
    }
}

export default ProductReviews;
